import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams, HttpResponse } from '@angular/common/http';
import { ParamContext } from '../../service/param.context';
import { VariableDetails } from '../model/variable-details';
import { SERVER_API_URL } from '../../../app.constants';
import { Observable } from 'rxjs';
import { VariableFilterRequest } from '../model/variable-filter-request';
import { VariableSearchRequest } from '../model/variable-search-request.model';
import { Variable } from '../model/variable';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../loading-indicator';
import { createRequestOption } from '../../model/request-util';

@Injectable()
export class VariableService {

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    getVariables() {
        const params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        return this.http.get<VariableDetails[]>(SERVER_API_URL + `crops/${this.paramContext.cropName}/variables`, {
            params, context: new HttpContext().set(EnableLoadingIndicator, true)
        });
    }

    /**
     * @deprecated Please, instead use {@link searchVariables}
     */
    filterVariables(request: VariableFilterRequest): Observable<VariableDetails[]> {
        let params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        Object.keys(request).forEach((key) => {
            const value = (request as any)[key];
            if (value !== undefined && value !== null) {
                if (Array.isArray(value)) {
                    value.forEach((val: any) => {
                        params = params.append(key, val);
                    });
                } else {
                    params = params.append(key, value);
                }
            }
        });
        return this.http.get<VariableDetails[]>(SERVER_API_URL + `crops/${this.paramContext.cropName}/variables/filter`, {
            params, context: new HttpContext().set(EnableLoadingIndicator, true)
        });
    }

    getVariableById(variableId: number): Observable<VariableDetails> {
        const params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        return this.http.get<VariableDetails>(SERVER_API_URL + `crops/${this.paramContext.cropName}/variables/${variableId}`, {
            params, context: new HttpContext().set(EnableLoadingIndicator, true)
        });
    }

    getStudyEntryVariables(studyId: number, variableTypeId: number): Observable<HttpResponse<VariableDetails[]>> {
        const url = SERVER_API_URL
            + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/entries/variables?variableTypeId=${variableTypeId}`;
        return this.http.get<VariableDetails[]>(url, { observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    searchVariables(req: VariableSearchRequest): Observable<HttpResponse<Variable[]>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/variables/search`;
        return this.http.post<Variable[]>(url, req, { observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    searchVariablesOntology(search: VariableSearchRequest, req: any): Observable<HttpResponse<Variable[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/variables/search`;
        return this.http.post<Variable[]>(url, search, {
            params,
            observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true)
        });
    }

    getVariablePairs(variableId: number): Observable<Variable[]> {
        const params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/variables/${variableId}/pairs`;
        return this.http.get<Variable[]>(url, { params, context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    update(variable: VariableDetails): Observable<HttpResponse<VariableDetails>> {
        const params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/variables/${variable.id}`;
        return this.http.put<VariableDetails>(url, variable, { params, observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    create(variable: VariableDetails): Observable<HttpResponse<{ id: string }>> {
        const params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/variables`;
        return this.http.post<{ id: string }>(url, variable, { params, observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    delete(variableId: string): Observable<HttpResponse<any>> {
        const params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/variables/${variableId}`;
        return this.http.delete<any>(url, { params, observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

}
